export const AuthorizedStates = ["empty", "success", "warning", "error"];

export interface UserSelection {
  selectedIds?: string[] | undefined;
  selectedSearchBy?: string;
  selectedHashtags?: string[] | undefined;
}
